import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useDriveThruContext } from 'state/service-mode/derived';

export const useIsVehicleDescriptionEnabled = (): boolean => {
  const { isDriveThru, isMobileOrderForDriveThru } = useDriveThruContext();
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );

  return (isDriveThru && isMobileOrderForDriveThruLaneEnabled) || isMobileOrderForDriveThru;
};
